import { Clipboard } from './Clipboard';
export const ClipboardPluginID = 'clipboard';
export const clipboardPlugin = {
    id: ClipboardPluginID,
    component: Clipboard
};
export function createClipboardPlugin(config) {
    return Object.assign(Object.assign({}, clipboardPlugin), { config });
}
